export default "__VITE_ASSET__C0G4COdD__"